import useSpendDataSchema from '/business/shared/components/questions/scope3/goods/shared/_hooks/useSpendDataSchema';
import type { QuestionSchemaType } from '/index';

export default function useGetCapitalGoodSpendDataSchema(): QuestionSchemaType {
  return useSpendDataSchema({ question: 'capitalGoods' });
}
